import React, { Component } from 'react'
import { Input } from 'react-bootstrap'
import { t, setLocale } from '../helpers/translate'
import { request } from '../helpers/request'
import { setMicrositeColour } from '../helpers/style'
import SeeADoctor from '../Logos/PPN_ASSETS/see_a_doctor.jpg'

import WalletCard2023StudyInsuredEN from '../Logos/PPN_ASSETS/WalletCard_2023_StudyInsured_en.jpg'
import WalletCard2023MyCanadaPlanEN from '../Logos/PPN_ASSETS/WalletCard_2023_MyCanadaPlan_en.jpg'
import WalletCard2023MSHEN from '../Logos/PPN_ASSETS/WalletCard_2023_MSH_en.jpg'

import WalletCard2023StudyInsuredFR from '../Logos/PPN_ASSETS/WalletCard_2023_StudyInsured_fr.jpg'
import WalletCard2023MyCanadaPlanFR from '../Logos/PPN_ASSETS/WalletCard_2023_MyCanadaPlan_fr.jpg'
import WalletCard2023MSHFR from '../Logos/PPN_ASSETS/WalletCard_2023_MSH_fr.jpg'

require('styles/PPNSearch.scss');
import ReactGA from "react-ga4";

let config = require('config');

class PPNSearch extends Component {

  signUpUrl = this.props.params.lang === 'en' ? "https://getmaple.ca/msh-en" : "http://getmaple.ca/msh-fr";

  constructor(props) {
    setLocale(props.params.lang);
    setMicrositeColour(props.params.microsite);

    sessionStorage.setItem('hide_navbar', true);
    document.body.style.backgroundColor = "white";
    super(props);

    this.state = {
      policyNumber: '',
      hasError: false,
      errorMessage: null,
      showWalletCard: false,
    };

    this.getAccessToken();

    ReactGA.initialize(config.default.PPN_google_analytics_measurement_id);

    this.fireEvent("ppn_search", "find_a_doctor_page");
  }

  fireEvent(category, action, isPolicySearch) {
    const { microsite, lang } = this.props.params;
    const { policyNumber } = this.state;

    const eventObject = {
      hitType: "event",
      eventCategory: category,
      eventAction: action,
      eventLabel: microsite,
      school_name: microsite,
      locale: lang,
    };

    if (isPolicySearch) {
      eventObject.policy_number = policyNumber ? policyNumber : 'NULL';
    }

    ReactGA.send(eventObject);
  }

  handlePolicySearchResponse(response) {
    const { microsite, lang } = this.props.params;
    const mapslyIdEn = '53523b948238459f8c86bd5bdbcacc59';
    const mapslyIdFr = '64647540d6b74a9d8cc761b2c4ff2be4';
    if (response.success) {
      this.setState({ hasError: false, errorMessage: null });
      this.fireEvent("ppn_search", "search_policy_success", true);
      this.fireEvent("ppn_search", "mapsly_visit");
      window.open(`${config.default.dashboard_url}/${microsite}/ppn_search/${lang}?mapsly_id=${lang == 'fr' ? mapslyIdFr : mapslyIdEn}`, '_blank')
    } else {
      this.fireEvent("ppn_search", "search_policy_failure", true);
      this.setState({ hasError: true, errorMessage: t(response.messages[0]) });
    }
  }

  searchActiveOrSoldPolicy() {

    const policyNumber = this.state.policyNumber.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

    this.setState({ policyNumber })

    request(`${config.default.api}/search/activeOrSoldPolicy`,
      'POST',
      { 'policy_number': policyNumber },
      this.handlePolicySearchResponse.bind(this),
      {
        'Content-Type': 'application/json'
      },
      true
    );
  }

  getAccessToken() {
    jQuery.ajax(
      {
        url: `${config.default.auth_base_api}/token/travel/basic`,
        method: 'POST',
        data: {
          token: config.default.guest_token,
        }
      }
    ).always((response, statusText) => {
      if (statusText == 'success') {
        sessionStorage.setItem('auth', 'Bearer' + ' ' + response['access_token']);
      }
    });
  }

  showWalletCard() {
    this.setState({
      showWalletCard: !this.state.showWalletCard
    });
    this.fireEvent("ppn_search", "show_wallet_card");
  }

  openStudyInsuredAssistance() {
    const { microsite, lang } = this.props.params;
    const studyInsuredAssistanceUrl = `https://www.studyinsured.com/${microsite}/${lang}/emergency-assistance`;
    this.fireEvent("ppn_search", "call_studyinsured_assistance");
    window.open(studyInsuredAssistanceUrl, '_blank')
  }

  mapslyIframe = (mapslyId) => {
    const { lang } = this.props.params;
    const englishDisclaimer = "DISCLAIMER: MSH International has created this list for your convenience only and does not recommend the services of any specific physician or other medical service provider. We assume no  responsibility or liability for the professional abilty or reputation of or the quality of services provided by the medical professionals medical facilities or pharmacies whose names appear in the following network. Names are listed alphabetically and/or by geographical proximity and the order in which they appear has no other significance. Professional credentials and areas of expertise indicated here reflect the information provided directly by the medical professionals facilities and pharmacies"
    const frenchDisclaimer = "AVIS DE NON-RESPONSABILITÉ : MSH International a créé cette liste pour votre commodité uniquement et ne recommande pas les services d’un·e médecin en particulier ou d’un·e autre prestataire de services médicaux. Nous déclinons toute responsabilité quant à la compétence professionnelle, à la réputation ou à la qualité des services fournis par les professionnel·le·s de la santé, les établissements médicaux ou les pharmacies dont les noms figurent dans le réseau suivant. Les noms sont classés par ordre alphabétique ou par proximité géographique, et l’ordre dans lequel ils apparaissent n’a pas d’autre signification. Les titres professionnels et les domaines d’expertise indiqués ici reflètent les renseignements fournis directement par les professionnel·le·s de la santé, les établissements médicaux et les pharmacies."
    return <div>
      <div className='mapsly_link'
        onClick={() => {
          this.fireEvent("ppn_search", "mapsly_maple_virtual_care");
          window.open(this.signUpUrl, '_blank')
        }}
      >
        {t('Want to connect to an online doctor instead? Click here.')}
      </div>
      <div dangerouslySetInnerHTML={{ __html: `<iframe allow="geolocation" src="https://app.mapsly.com/map/${mapslyId}" style="width: 100%; height: 80vh; border: none"></iframe>` }} />
      <div style={{ padding: '10px 20px 2px 20px' }}>
        {lang === 'en' ? englishDisclaimer : frenchDisclaimer}
      </div>
    </div>
  };


  render() {
    const { lang } = this.props.params;
    const learnMoreUrl = `http://docs.mshtravel.com/docs/Microsites/Maple/Maple_WelcomeGuide_${lang}.pdf`
    const mapslyId = this.props.location.query.mapsly_id;

    return (
      mapslyId ? this.mapslyIframe(mapslyId) : (
        <div className='container' id='ppn_search'>
          {this.props.location.query.hide != "true" &&
            <div>
              <div className='page-heading'>
                <h1 className='page-heading main'>{t('Find A Doctor')}</h1>
              </div>

              <div className='emergency-card align-items-center'>
                <div className='emergency-icon' />
                <div className='emergency-text'>
                  <div>
                    {t('If you have an emergency, call 911 or go to the hospital.')}
                  </div>
                  <div>
                    {t('Whenever you need medical care,')}
                    <a className='link' href="#" onClick={() => {
                      this.openStudyInsuredAssistance();
                    }}>
                      {t("call StudyInsured™ Assistance.")}
                      {lang === 'fr' && <span className='superscript'>MC.</span>}
                    </a>
                  </div>
                </div>
              </div>

              <hr className='ppn_search_hr' />

              <div className='div-center page-heading'>
                <h2 className='icon-heading'>{t('See a doctor online for')}:</h2>
              </div>

              <div className='disease-wrapper'>
                <div className="icon-wrapper">
                  <i className="cough-sore-throat-icon" />
                  <div className="text">{t('Cough/Sore Throat')}</div>
                </div>
                <div className="icon-wrapper">
                  <i className="ear-ache-icon" />
                  <div className="text">{t('Earache')}</div>
                </div>
                <div className="icon-wrapper">
                  <i className="uti-icon" />
                  <div className="text">{t('Urinary Tract Infection')}</div>
                </div>
                <div className="icon-wrapper">
                  <i className="upset-stomach-icon" />
                  <div className="text">{t('Upset Stomach')}</div>
                </div>
                <div className="icon-wrapper">
                  <i className="sinus-infection-icon" />
                  <div className="text">{t('Sinus Infection')}</div>
                </div>
                <div className="icon-wrapper">
                  <i className="rash-hives-allergies-icon" />
                  <div className="text">{t('Rash/Hives/ Allergies')}</div>
                </div>
                <div className="icon-wrapper">
                  <i className="cold-flu-icon" />
                  <div className="text">{t('Cold/Flu')}</div>
                </div>
              </div>

              <div className='find-a-doctor'>
                <img className='doctor-img img-responsive' src={SeeADoctor} />
                <div>
                  <h3 className='doctor-text'>
                    {t("Video chat with a doctor on your phone, tablet or computer for these issues and more.")}
                  </h3>
                  <p className='text'>
                    {t("Fast - Easy - No travel or waiting rooms - Prescriptions available")}
                  </p>
                  <div className='button_wrapper'>
                    <button
                      className="btn btn-submit button-secondary"
                      onClick={() => {
                        this.fireEvent("ppn_search", "maple_virtual_care");
                        window.open(this.signUpUrl, '_blank')
                      }}
                    >
                      {t('sign up / login')}
                    </button>
                    <button
                      className="btn btn-submit button-secondary"
                      onClick={() => {
                        this.fireEvent("ppn_search", "maple_learn_more");
                        window.open(learnMoreUrl, '_blank')
                      }}
                    >
                      {t('learn more')}
                    </button>
                  </div>
                </div>
              </div>

              <hr className='ppn_search_hr' />

              <div className='div-center'>
                <h2 className='page-heading'>{t('Find a medical provider')}</h2>
                <h3 className='page-heading'>{t('For an in-person visit')}</h3>
              </div>

              <div className='row-flex prepare-visit'>
                <div className='col-md-1 center-children icon-wrapper'>
                  <i className='info-icon' />
                </div>
                <div className='col-md-11'>
                  <div className='column-flex'>
                    <h4 className='title'>
                      {t('Prepare for your visit')}:
                    </h4>
                    <div className='row'>
                      <div className='col-md-4 text'>
                        <span>1. </span>
                        {t("Call the provider to check if you need an appointment and/or confirmation of coverage.")}
                      </div>
                      <div className='col-md-4 text'>
                        <span>2. </span>
                        {lang == 'fr' ?
                          (
                            <span>
                              <a className='link' onClick={() => {
                                this.openStudyInsuredAssistance()
                              }}>
                                {t("call StudyInsured™ Assistance.")}
                                <span className='superscript'>MC</span>
                              </a>
                              {""} {t("To get confirmation of coverage,")}
                            </span>
                          ) : (
                            <span>{t("To get confirmation of coverage,")}
                              <a className='link' onClick={() => {
                                this.openStudyInsuredAssistance()
                              }}>
                                {t("call StudyInsured™ Assistance.")}
                              </a>
                            </span>
                          )}
                      </div>
                      <div className='col-md-4 text'>
                        <span>3. </span>
                        {t("Bring confirmation of coverage, photo ID, and your insurance wallet card to your appointment.")}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }

          <div className='center-children policy-search'>
            <h5 className='title'>
              {t("Enter Your Policy Number to Find the Closest Medical Provider")}
            </h5>

            {this.state.hasError &&
              <div className='error'>
                {this.state.errorMessage}
              </div>
            }
            <div className='policy-search-input-wrapper div-center'>
              <div className='col-md-10'>
                <Input
                  placeholder={`${t('Policy Number')} eg: MCP999123456`}
                  type='text'
                  className='input'
                  value={this.state.policyNumber}
                  onKeyPress={(event) => {
                    if (event.charCode === 13) {
                      this.searchActiveOrSoldPolicy()
                    }
                  }}
                  onChange={(event) => {
                    this.setState({ policyNumber: event.target.value })
                  }
                  }
                />
              </div>
              <div className='col-md-2'>
                <button
                  className="btn btn-submit button-secondary"
                  onClick={this.searchActiveOrSoldPolicy.bind(this)}
                >
                  {t('Search')}
                </button>
              </div>

            </div>
            <p className='description'>
              {t("You can find your policy number on your insurance wallet card or your insurance confirmation.")}
            </p>

            <p className='link' onClick={this.showWalletCard.bind(this)}>
              {t("View insurance wallet card examples")}
            </p>

            {this.state.showWalletCard &&
              <div className='wallet_card'>
                <div className='heading'>
                  {t("Where do I find my policy number?")}
                </div>
                <div className='text'>
                  {t("You can find your policy number on your insurance confirmation letter and on vour insurance wallet card.")}
                </div>
                <div className='image_wrapper'>
                  <p className='text'>
                    {t("StudyInsured™")}
                    {lang == 'fr' && <span className='superscript'>MC</span>}
                    :
                  </p>
                  <img src={lang === 'en' ? WalletCard2023StudyInsuredEN : WalletCard2023StudyInsuredFR} className='img-blog' />
                </div>
                <div className='image_wrapper'>
                  <p className='text'>
                    {t("MyCanadaPlan:")}
                  </p>
                  <img src={lang === 'en' ? WalletCard2023MyCanadaPlanEN : WalletCard2023MyCanadaPlanFR} className='img-blog' />
                </div>
                <div className='image_wrapper'>
                  <p className='text'>
                    {t("MSH and RIMI:")}
                  </p>
                  <img src={lang === 'en' ? WalletCard2023MSHEN : WalletCard2023MSHFR} className='img-blog' />
                </div>
              </div>
            }

          </div>
        </div>
      )
    )
  }
}

PPNSearch.displayName = 'PPN Search';
export default PPNSearch;



// WEBPACK FOOTER //
// ./src/components/PPNSearch.js